/**
 * Utilitários de busca no grafo.
 *
 * Suporta:
 *   - substring de hostname/sysname
 *   - IP exato: "10.100.126.36"
 *   - Faixa parcial: "10.100.126" → casa com qualquer 10.100.126.*
 *   - CIDR: "10.100.126.0/24"
 *   - ASN: "AS266354" ou "266354"
 */

function ipToInt(ip) {
  if (!ip || typeof ip !== 'string') return null;
  const parts = ip.split('.').map(Number);
  if (parts.length !== 4 || parts.some((p) => isNaN(p) || p < 0 || p > 255)) return null;
  return ((parts[0] << 24) >>> 0) + ((parts[1] << 16) >>> 0) + ((parts[2] << 8) >>> 0) + parts[3];
}

function ipInCidr(ip, cidr) {
  if (!cidr.includes('/')) return false;
  const [network, prefixStr] = cidr.split('/');
  const prefix = parseInt(prefixStr, 10);
  if (isNaN(prefix) || prefix < 0 || prefix > 32) return false;
  const ipInt = ipToInt(ip);
  const netInt = ipToInt(network);
  if (ipInt === null || netInt === null) return false;
  if (prefix === 0) return true;
  const mask = (0xFFFFFFFF << (32 - prefix)) >>> 0;
  return (ipInt & mask) === (netInt & mask);
}

/**
 * Retorna uma função predicate(node) => boolean baseada na query.
 */
export function makeSearchPredicate(query) {
  const q = (query || '').trim();
  if (!q) return null;
  const needle = q.toLowerCase();

  // CIDR?
  if (q.includes('/') && /\d+\.\d+\.\d+\.\d+\/\d+/.test(q)) {
    return (node) => {
      const ip = node.mgmt_ip || '';
      return ipInCidr(ip, q);
    };
  }

  // IP exato
  if (/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(q)) {
    return (node) => (node.mgmt_ip || '') === q;
  }

  // ASN
  const asnMatch = q.match(/^as(\d+)$/i) || q.match(/^(\d{4,})$/);
  if (asnMatch) {
    const asn = asnMatch[1];
    return (node) => String(node.asn || '') === asn;
  }

  // Faixa parcial tipo "10.100.126"
  if (/^\d{1,3}(\.\d{1,3}){0,2}$/.test(q)) {
    return (node) => (node.mgmt_ip || '').startsWith(q);
  }

  // Substring em label/sysname/vendor/ip
  return (node) => {
    const label = (node.label || '').toLowerCase();
    const sys = (node.sysname || '').toLowerCase();
    const ip = (node.mgmt_ip || '').toLowerCase();
    const vendor = (node.vendor || '').toLowerCase();
    return (
      label.includes(needle) ||
      sys.includes(needle) ||
      ip.includes(needle) ||
      vendor.includes(needle)
    );
  };
}
